import { Box, Card, Typography } from '@mui/material';
import { useSelector } from 'src/legacy/redux/store';

export const BasicInfoCard = () => {
  const { selectedClient } = useSelector((state) => state.client);

  const displayName = `${selectedClient?.first_name || ''} ${
    selectedClient?.last_name || ''
  }`;

  return (
    <Card
      sx={{
        mb: 3,
        position: 'relative',
      }}
    >
      <Box
        sx={{
          mx: 3,
          my: 2.5,
        }}
      >
        <Typography variant="h4">{displayName}</Typography>
      </Box>
    </Card>
  );
};
